<template>
  <v-card>
    <v-card-title>
      Enter a Release# to allocate the material
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-autocomplete
            v-model="jobId"
            :items="jobs"
            hide-details="true"
            item-value="id"
            :item-text="item => `${item.code} - ${item.name}; ${item.reference}`"
            clearable
            :loading="jobsAreLoading"
          >
            <template #selection="{ item }">
              <span>
                <span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span>
              </span>
            </template>
            <template #label>
              {{ jobLabel }}<red-asterisk />
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="normal" class="mr-2 ml-10" @click="close">
        CLOSE
      </v-btn>
      <v-btn color="primary" @click="submit" :loading="isLoading">
        SUBMIT
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import * as allocationApi from '../../../api/InventoryAllocationApi';
import RedAsterisk from '../../RedAsterisk.vue';

export default {
  components: {
    RedAsterisk
  },
  emits: ['allocationInitialized', 'close'],
  data: () => ({
    jobId: null,
    jobs: [],
    jobsAreLoading: false,
    isLoading: false,
  }),
  computed: {
    ...mapGetters([
      'businessRulesGetBoolean',
    ]),
    jobLabel() {
      return this.businessRulesGetBoolean('Jobs Rename to Release') ? 'Release' : 'Job';
    }
  },
  watch: {

  },
  created() {
    this.jobsAreLoading = true;
    this.$api.job.readDDL({}).then(res => {
      this.jobs = res;
      this.jobsAreLoading = false;
    });
  },
  methods: {
    async submit() {
      if (!this.jobId) return this.$bus.$emit('showError', `Please select the ${this.jobLabel}`);
      const data = { job_id: this.jobId };
      try {
        this.isLoading = true;
        const res = await allocationApi.createAllocation(data);
        this.$emit('allocation-initialized', res.id);
        this.reset();
      } catch (e) {
        console.error(e);
        this.$bus.$emit('showError', `Failed to create an allocation. ${e.response?.data || ''}`);
      } finally {
        this.isLoading = false;
      }
    },
    reset() {
      this.jobId = null;
    },
    close() {
      this.reset();
      this.$emit('close');
    }
  },
};
</script>